"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _getProductNameText = require("ui-addon-upgrades/_core/common/adapters/getProductNameText");

var _upgradeProducts = require("../data/upgradeData/properties/upgradeProducts");

var BannerSubtext = function BannerSubtext(_ref) {
  var subText = _ref.subText,
      linkUse = _ref.linkUse,
      upgradeProduct = _ref.upgradeProduct,
      onLinkClick = _ref.onLinkClick;
  return _react.default.createElement("p", {
    className: "m-bottom-0 m-right-4 private-upgrades-message-text"
  }, subText, upgradeProduct !== _upgradeProducts.upgradeProducts.STARTER_CONTACTS && _react.default.createElement(_UIButton.default, {
    use: linkUse,
    className: "private-upgrades-message-link m-left-1",
    onClick: onLinkClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "upgrades.message.productName",
    options: {
      productName: (0, _getProductNameText.getProductNameText)(upgradeProduct)
    }
  })));
};

BannerSubtext.propTypes = {
  subText: _react.PropTypes.string.isRequired,
  upgradeProduct: _react.PropTypes.string.isRequired,
  linkUse: _react.PropTypes.string.isRequired,
  onLinkClick: _react.PropTypes.func.isRequired
};
var _default = BannerSubtext;
exports.default = _default;
module.exports = exports.default;